import getActions from '../../shared/store/actionsFactory';
import { adminPageNames, adminPageTitles } from '../../shared/adminPageNames';
import getApi from '../../shared/apiFactory';

import Config from '../../../config';
import agGridConfig from '../../../agGridConfig';

import {
  FETCH_INITIAL_DATA_FOR_TAX_BOOKING_ENTITY_MODAL,
  FETCH_INITIAL_DATA_FOR_TAX_BOOKING_ENTITY_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_TAX_BOOKING_ENTITY_MODAL_FAILURE,
  FETCH_TBE_COMPANY_CODES_FOR_TAX_BOOKING_ENTITY_MODAL,
  FETCH_TBE_COMPANY_CODES_FOR_TAX_BOOKING_ENTITY_MODAL_SUCCESS,
  FETCH_TBE_COMPANY_CODES_FOR_TAX_BOOKING_ENTITY_MODAL_FAILURE,
} from './types';
import {
  fetchEnabledFlagValues as fetchEnabledFlagValuesApi,
  fetchCompanyCodes as fetchCompanyCodesApi,
  fetchTBECompanyCodes as fetchTBECompanyCodesApi,
  fetchImportStatus as fetchImportStatusApi,
  fetchUsTaxTypes as fetchUsTaxTypesApi,
  fetchLocalTaxTypes as fetchLocalTaxTypesApi,
  fetchTBEtypes as fetchTBEtypesApi,
} from '../api';

import { fetchingError } from '../../../shared/store/actions';
import { errorNotification } from '../../../shared/store/notificationActions';

export const sharedActions = getActions(adminPageNames.TAX_BOOKING_ENTITIES, {
  pageTitle: adminPageTitles.TAX_BOOKING_ENTITIES,
  api: getApi({
    pageTitle: adminPageTitles.TAX_BOOKING_ENTITIES,
    endpoints: {
      FETCH: Config.endpoints.FETCH_TAX_BOOKING_ENTITIES,
      INSERT: Config.endpoints.ADD_TAX_BOOKING_ENTITY,
      UPDATE: Config.endpoints.UPDATE_TAX_BOOKING_ENTITY,
      DELETE: Config.endpoints.DELETE_TAX_BOOKING_ENTITY,
    },
  }),
  sortingField: 'companyCode',
  agGridConfig: agGridConfig.adminTaxBookingEntity,
});

export const fetchInitialDataForTaxBookingEntityModal = period => async dispatch => {
  dispatch({ type: FETCH_INITIAL_DATA_FOR_TAX_BOOKING_ENTITY_MODAL });
  try {
    const enabledFlagValuesResponse = await fetchEnabledFlagValuesApi();
    const companyCodesResponse = await fetchCompanyCodesApi({ periodName: period.name });
    const importStatusResponse = await fetchImportStatusApi();
    const usTaxTypesResponse = await fetchUsTaxTypesApi();
    const localTaxTypesResponse = await fetchLocalTaxTypesApi();
    const tbeTypesResponse = await fetchTBEtypesApi();

    return dispatch({
      type: FETCH_INITIAL_DATA_FOR_TAX_BOOKING_ENTITY_MODAL_SUCCESS,
      enabledFlagValues: enabledFlagValuesResponse,
      companyCodes: companyCodesResponse,
      importStatus: importStatusResponse,
      usTaxTypeValues: usTaxTypesResponse,
      localTaxTypeValues: localTaxTypesResponse,
      tbeTypeValues: tbeTypesResponse,
    });
  } catch (error) {
    dispatch({ type: FETCH_INITIAL_DATA_FOR_TAX_BOOKING_ENTITY_MODAL_FAILURE });
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const fetchTBECompanyCodesForTaxBookingEntityModal = entityToEditData => async dispatch => {
  dispatch({ type: FETCH_TBE_COMPANY_CODES_FOR_TAX_BOOKING_ENTITY_MODAL });
  try {
    const tbeCompanyCodesResponse = await fetchTBECompanyCodesApi({ periodName: entityToEditData.periodName,
      companyCode: entityToEditData.companyCode, tbeLegalEntity: entityToEditData.tbeLegalEntity });
    return dispatch({
      type: FETCH_TBE_COMPANY_CODES_FOR_TAX_BOOKING_ENTITY_MODAL_SUCCESS,
      tbeCompanyCodes: tbeCompanyCodesResponse,
    });
  } catch (error) {
    dispatch({ type: FETCH_TBE_COMPANY_CODES_FOR_TAX_BOOKING_ENTITY_MODAL_FAILURE });
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};
